import angular from 'angular'

import { WrCustomerBadgeComponent } from './wr-customer-badge.component'

angular
  .module('webregister.components')
  .component('wrCustomerBadge', WrCustomerBadgeComponent)
